// extracted by mini-css-extract-plugin
module.exports = {"geo-switcher-container":"_6eb00b8e53--geo-switcher-container--1xoiJ","geo-switcher":"_6eb00b8e53--geo-switcher--w2KAW"};